// The logged-in username IS the account's email (e.g. "sarah@kabilah.com") —
// see Login.js, which stores whatever /login returns as `username` verbatim.
export function getCurrentUserEmail() {
  return localStorage.getItem('username') || '';
}
